/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Box,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from '@mui/material';
import { ModuleConfig } from '@schamburg-web/interfaces';
import { DisplayCard } from '@schamburg-web/lakecounty';
import CardCloseButton from '../../components/CardCloseButton/CardCloseButton';
import UpdatedTimeStamp from '../../components/UpdatedTimeStamp/UpdatedTimeStamp';
import { getLocationDescription, getNormalizedIcon } from '../utils';
import { TravelTimesAvatar } from './TravelTimesMarker';

const directionToText = (dir: string | undefined): string => {
  switch (dir?.toUpperCase()) {
    case 'N':
      return 'NB';
    case 'E':
      return 'EB';
    case 'S':
      return 'SB';
    case 'W':
      return 'WB';
    default:
      return 'N/A'; // fallback if direction is missing or invalid
  }
};

const getSubheaderText = (normalizedIcon: any): string => {
  const dirText = directionToText(normalizedIcon?.dir) ?? '';
  if (normalizedIcon && normalizedIcon.location) {
    return `${dirText}  ${getLocationDescription(normalizedIcon)} | ${
      normalizedIcon.sectionLength
        ? `${normalizedIcon.sectionLength} mi`
        : 'N/A'
    }`;
  }
  return 'Travel Time';
};

const TTDisplayCard: React.FC<{
  icon: any;
  module: ModuleConfig;
}> = ({ icon, module }) => {
  const normalizedIcon = getNormalizedIcon(icon);
  const { aveTravelTime, traveltime } = normalizedIcon || {};

  return (
    <Box sx={{ maxWidth: 500, width: '100%', position: 'relative' }}>
      <DisplayCard icon={icon} module={module}>
        <CardHeader
          action={<CardCloseButton />}
          avatar={
            <Box
              sx={{
                width: 40,
                height: 40,
              }}
            >
              <TravelTimesAvatar icon={normalizedIcon} module={module} />
            </Box>
          }
          title={
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography variant="h6">
                  {traveltime !== undefined && traveltime !== null
                    ? `${traveltime} minutes`
                    : 'Travel Time'}
                </Typography>
              </Box>
            </Box>
          }
          sx={{ paddingBottom: 1 }}
          subheader={
            <Typography variant="subtitle2" color="text.secondary">
              {getSubheaderText(normalizedIcon)}
            </Typography>
          }
        />

        <Box>
          <Divider sx={{ width: '90%', marginLeft: '5%' }} />
        </Box>
        <CardContent sx={{ pt: 2, pb: 0, '&:last-child': { pb: 1 } }}>
          <Box display="flex" flexDirection="column" gap={1}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="body2" color="text.secondary">
                Typical Travel Time
              </Typography>
              <Typography variant="body2" fontWeight="medium">
                {aveTravelTime ? `${aveTravelTime} min` : 'N/A'}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" justifyContent="flex-end" mt={1}>
            <UpdatedTimeStamp icon={normalizedIcon} />
          </Box>
        </CardContent>
      </DisplayCard>
    </Box>
  );
};

export default TTDisplayCard;
